<template>
  <router-view/>

  <ModalConfirm
      v-model="showAppVersionModal"
      :confirmationQuestion="$t('general.new_app_version_available')"
      :hideCloseButton="true"
      :hideCancelButton="true"
      :classes="'bg-blur'"
      :onConfirm="reloadPage"/>

</template>

<script setup>
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {piniaUserStore} from '@/store/piniaUserStore';
import {piniaModalStore} from './store/piniaModalStore';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";
import {computed, onBeforeMount, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import ModalConfirm from './components/modal/ModalConfirm.vue';
import {
  applyDynamicPrimaryColor,
  applyDynamicSidebarColor,
  applyDynamicSidebarIconColor,
  applyDynamicSidebarLinkColor
} from '@/shared/utils/ThemeUtils';

const token = localStorage.getItem('token');
const {t} = useI18n();

const modalStore = piniaModalStore();
const showAppVersionModal = computed(() => modalStore.modal);

const reloadPage = () => {
  modalStore.setModalData(false);
  window.location.replace(window.location.href);
};

onBeforeMount(async () => {
  if (token) {
    const userStore = piniaUserStore();
    await userStore.piniaGetUser();

    const enumStore = piniaEnumsStore();
    await enumStore.getEnums(t);

    const companySettingsStore = piniaCompanySettingsStore()
    await companySettingsStore.getCompanySettings()


    if (companySettingsStore?.companySettings?.colorCode) {
      applyDynamicPrimaryColor(companySettingsStore.companySettings.colorCode);
    }
    if (companySettingsStore?.companySettings?.sidebarColorCode) {
      applyDynamicSidebarColor(companySettingsStore.companySettings.sidebarColorCode);
    }
    if (companySettingsStore?.companySettings?.sidebarIconColorCode) {
      applyDynamicSidebarIconColor(companySettingsStore.companySettings.sidebarIconColorCode);
    }
    if (companySettingsStore?.companySettings?.sidebarLinkColorCode) {
      applyDynamicSidebarLinkColor(companySettingsStore.companySettings.sidebarLinkColorCode);
    }

    watch(
        () => companySettingsStore?.companySettings?.colorCode,
        (newColor) => {
          if (newColor) applyDynamicPrimaryColor(newColor);
        }
    );
    watch(
        () => companySettingsStore?.companySettings?.sidebarColorCode,
        (newColor) => {
          if (newColor) applyDynamicSidebarColor(newColor);
        }
    );
    watch(
        () => companySettingsStore?.companySettings?.sidebarIconColorCode,
        (newColor) => {
          if (newColor) applyDynamicSidebarIconColor(newColor);
        }
    );
    watch(
        () => companySettingsStore?.companySettings?.sidebarLinkColorCode,
        (newColor) => {
          if (newColor) applyDynamicSidebarLinkColor(newColor);
        }
    );
  }
});
</script>

<style></style>
